import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'wego-sort-list',
  styles: [`
    .sort-icon {
      float: right;
      line-height: 22px;
    }
  `],
  template: `
  <span [hidden]="sortType == fieldName" class="fa fa-sort fa-fw sort-icon" style="color: #888;"></span>
  <span [hidden]="!(sortType == fieldName && !sortReverse)" class="fa fa-sort-desc fa-fw sort-icon"></span>
  <span [hidden]="!(sortType == fieldName && sortReverse)" class="fa fa-sort-asc fa-fw sort-icon"></span>
  `,
})

export class SortListComponent implements OnInit, OnDestroy {
  @Input('SortType') sortType: any;
  @Input('SortReverse') sortReverse: any;
  @Input('FieldName') fieldName: any;

  searchTerm: string;

  constructor() { }

  ngOnInit() {
  }

  ngOnDestroy() { }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/sort-list.component.ts